/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RestoreDefaultBreaksRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {RestoreDefaultBreaksResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const restoreDefaultBreaks = (request: RestoreDefaultBreaksRequest, options?: CashRequestOptions) => post<RestoreDefaultBreaksRequest, RestoreDefaultBreaksResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/RestoreDefaultBreaks", request, {...options, rejectOnError: true })